import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import JivoChatGate from './components/JivoChatGate';
import FloatingChat from './components/FloatingChat';
import ScrollToTop from './components/ScrollToTop';
import SeoHead from './components/SeoHead';
import CookieBanner from './components/CookieBanner';
import { Toaster } from 'react-hot-toast';
// Rotalar tembel (lazy) yüklenir → ana paket küçülür, ilk boyama hızlanır.
// Her sayfa yalnızca gerçekten ziyaret edildiğinde ayrı bir parça olarak in/indirilir.
const HomePage = lazy(() => import('./pages/HomePage'));
const PackagesPage = lazy(() => import('./pages/PackagesPage'));
const RegisterPage = lazy(() => import('./pages/RegisterPage'));
const LoginPage = lazy(() => import('./pages/LoginPage'));
const ForgotPasswordPage = lazy(() => import('./pages/ForgotPasswordPage'));
// Televizyonu hesaba bağlama (TV'de gösterilen kodun girildiği sayfa)
const TvPairingPage = lazy(() => import('./pages/TvPairingPage'));
const ResetPasswordPage = lazy(() => import('./pages/ResetPasswordPage'));
const PaymentPage = lazy(() => import('./pages/PaymentPage'));
const DetailPage = lazy(() => import('./pages/DetailPage'));
const ProfilePage = lazy(() => import('./pages/ProfilePage'));
const PlayerPage = lazy(() => import('./pages/PlayerPage'));
const LiveTvPage = lazy(() => import('./pages/LiveTvPage'));
const AdminPage = lazy(() => import('./pages/AdminPage'));
const MoviesPage = lazy(() => import('./pages/MoviesPage'));
const SeriesPage = lazy(() => import('./pages/SeriesPage'));
const LegalPage = lazy(() => import('./pages/LegalPage'));
const ExplorePage = lazy(() => import('./pages/ExplorePage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));
const ManageProfilesPage = lazy(() => import('./pages/ManageProfilesPage'));
const ProfileSelectPage = lazy(() => import('./pages/ProfileSelectPage'));
const MyListPage = lazy(() => import('./pages/MyListPage'));
const HelpCenterPage = lazy(() => import('./pages/HelpCenterPage'));

// Sayfa parçası inerken gösterilen sade tam ekran yükleyici (arka planla aynı renk).
function RouteFallback() {
    return <div style={{ minHeight: '100vh', background: '#0a0a0a' }} />;
}

function App() {
    useEffect(() => {
        const loader = document.getElementById('app-loader');
        if (loader) {
            loader.classList.add('hide');
            setTimeout(() => loader.remove(), 500);
        }
    }, []);

    return (
        <Router>
            <ScrollToTop />
            <SeoHead />
            <JivoChatGate />
            <FloatingChat />
            <CookieBanner />
            <Toaster 
                position="top-right" 
                toastOptions={{ 
                    style: { background: '#1c1c1e', color: '#f0edf2', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.1)', boxShadow: '0 8px 30px rgba(0,0,0,0.5)' }
                }} 
            />
            <Suspense fallback={<RouteFallback />}>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/giris-yap" element={<LoginPage />} />
                <Route path="/sifremi-unuttum" element={<ForgotPasswordPage />} />
                <Route path="/sifre-sifirla" element={<ResetPasswordPage />} />
                <Route path="/uye-ol" element={<RegisterPage />} />
                <Route path="/paketler" element={<PackagesPage />} />
                <Route path="/detay/:id" element={<DetailPage />} />
                <Route path="/canli-tv" element={<LiveTvPage />} />
                <Route path="/filmler" element={<MoviesPage />} />
                <Route path="/diziler" element={<SeriesPage />} />
                <Route path="/kesfet/:genre" element={<ExplorePage />} />
                <Route path="/yasal/:type" element={<LegalPage />} />
                <Route path="/yardim" element={<HelpCenterPage />} />
                {/* Televizyon eşleştirme: giriş kontrolü sayfanın kendisinde —
                    PrivateRoute yönlendirmesi karekoddan gelen ?code parametresini
                    düşürürdü. */}
                <Route path="/tv" element={<TvPairingPage />} />

                {/* Misafir önizleme için açık (erişim kontrolü PlayerPage içinde) */}
                <Route path="/izle/:id" element={<PlayerPage />} />

                {/* Giriş gerektiren sayfalar */}
                <Route path="/odeme" element={<PrivateRoute><PaymentPage /></PrivateRoute>} />
                <Route path="/profil" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
                <Route path="/profiller" element={<PrivateRoute><ManageProfilesPage /></PrivateRoute>} />
                <Route path="/profil-sec" element={<PrivateRoute><ProfileSelectPage /></PrivateRoute>} />
                <Route path="/listem" element={<PrivateRoute><MyListPage /></PrivateRoute>} />

                {/* Sadece admin */}
                <Route path="/admin" element={<PrivateRoute adminOnly><AdminPage /></PrivateRoute>} />

                {/* Eşleşmeyen tüm yollar → 404 */}
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
            </Suspense>
        </Router>
    );
}

export default App;